import React from 'react';

import {
  AcademyProjectDetails,
  getAcademyProjectDetails,
  useGetSuperBatchProjectQuery,
} from 'features/classCreation';
import EditSuperBatchProjectForm from '../EditSuperBatchProjectForm';
import ErrorLayout from 'components/ErrorLayout';
import Loader from 'components/Loader';
import SectionHeading from 'components/SectionHeading';

export default function SuperBatchProjectDetails({
  sbatGroup,
  handleModalClose,
  superBatchProjectId,
}) {
  const {
    data,
    isLoading,
    error: superBatchProjectsError,
  } = useGetSuperBatchProjectQuery(superBatchProjectId, {
    skip: !superBatchProjectId,
  });

  const sbatGroupProjectDetails = getAcademyProjectDetails(
    data?.data?.academy_project
  );

  if (isLoading) {
    return <Loader />;
  } else if (superBatchProjectsError) {
    return (
      <ErrorLayout
        title="Failed to load Case Study"
        message={
          superBatchProjectsError.data?.message ||
          'Something went wrong! Try again later'
        }
      />
    );
  } else if (sbatGroupProjectDetails) {
    return (
      <>
        <SectionHeading
          title="CASE STUDY DETAILS"
          className="m-b-s"
        />
        <AcademyProjectDetails
          academyProjectDetails={sbatGroupProjectDetails}
        />
        <EditSuperBatchProjectForm
          sbatGroup={sbatGroup}
          superBatchProject={data?.data}
          handleModalClose={handleModalClose}
        />
      </>
    );
  }
}
